import type { GeneralConfig } from '@shared/types/Config';

export const projectConfig: GeneralConfig = {
    sortFieldMap: {},
};
